<table width="{{getRatingWidth()}}">
  <tr>
    @for (star of stars; track star) {
      <td nowrap width="40px" >
        <mat-icon
          class="{{getRatingClass(star)}}" [ngClass]="{'large': size == 'large', 'medium': size == 'medium', 'small': size == 'small'}">
          {{getRatingIcon(star)}}
        </mat-icon>
      </td>
    }
  </tr>
</table>
